import React from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import { system } from '../../theme/system';
import { ColorModeProvider } from './color-mode';
import { Toaster } from './toaster';

export function Provider({ children }) {
  return (
    <ChakraProvider value={system}>
      <ColorModeProvider>
        {children}
        <Toaster />
      </ColorModeProvider>
    </ChakraProvider>
  );
}
